import { Injectable, NgZone } from "@angular/core";
import { Observable } from "rxjs";
import { HttpInterceptor } from '../../common/services/httpInterceptor.service';

@Injectable({
  providedIn: 'root'
})
export class EventHandlerService {
  constructor(private _zone: NgZone,
    private httpInterceptorService: HttpInterceptor
  ) { }

  getServerSentEvent(url: string): Observable<any> {
    return Observable.create(observer => {
      const eventSource = this.httpInterceptorService.getEventSource(url);

      eventSource.onmessage = event => {
        this._zone.run(() => {
          observer.next(event);
        });
      };

      eventSource.onerror = error => {
        // observer.error(error);
        // eventSource.close();
        this._zone.run(() => {
          observer.error(error);
          eventSource.close();
        });
      };
    });
  }

  /*** Sends the status event and gets the redirectional task key */
  public sendEventStatus(url: string, data: {}): Observable<any> {
    return this.httpInterceptorService.Post(url, data);
  }

}
